/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';

import {SignalAdminResourcePageState} from '../common/controller/signal-admin-resource-page-state';
import {SiteGroupModel} from './site-group-api.service';
import {AdminResourcePagesModule} from '../common/controller/admin-resource-pages.module';
import {SiteGroupAnalysisPageComponent} from './site-group-analysis-page.component';
import {SiteGroupEditPageComponent} from './site-group-edit-page.component';

@Component({
  standalone: true,
  imports: [AdminResourcePagesModule, SiteGroupAnalysisPageComponent, SiteGroupEditPageComponent],
  selector: 'adn-site-group-item-page',
  template: `
    <adn-two-panel-layout>
      <adn-site-group-edit-page leftPanel [state]="state"></adn-site-group-edit-page>
      <adn-site-group-analysis-page rightPanel [model]="state.model()" [isNew]="state.isNew()"></adn-site-group-analysis-page>
    </adn-two-panel-layout>
  `
})
export class SiteGroupItemPageComponent {
  @Input() state: SignalAdminResourcePageState<SiteGroupModel>;
}
